export function setCurrentCustomer(state, payload) {
  state.current = payload;
}
